import { render, staticRenderFns } from "./ShueiJinJiouBanner.vue?vue&type=template&id=5f14017b"
import script from "./ShueiJinJiouBanner.vue?vue&type=script&lang=js"
export * from "./ShueiJinJiouBanner.vue?vue&type=script&lang=js"
import style0 from "./ShueiJinJiouBanner.vue?vue&type=style&index=0&id=5f14017b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports